<template src="../../templates/pwa/animalSearch.pug" lang="pug"></template>

<style src="../../sass/pwa/animalSearch.sass" lang="sass" scoped></style>

<script>
import $axios from '../../axios'
import { mapGetters } from 'vuex'
import { getAge } from '../../libs/age'
import { getFecondityStatus } from '../../libs/state'
import _each from 'lodash/each'

export default {
    name: 'animalSearch',
    data() {
        return {
            searchInput: '',
            searchResults: [],
            loadingResults: false,
            getAge
        }
    },
    computed: {
        ...mapGetters(['selectedFarm'])
    },
    methods: {
        searchAnimals(e) {
            if (e.target.value.length >= 2) {
                this.loadingResults = true
                let self = this
                $axios
                    .get(`/api/animal/search?q=${e.target.value}&f=${this.selectedFarm.id}`)
                    .then(response => {
                        self.searchResults = []
                        _each(response.data, function(a) {
                            self.searchResults.push(getFecondityStatus(a))
                        })
                        // this.searchResults = response.data
                        this.loadingResults = false
                    })
                    .catch(error => {
                        console.log(error)
                    })
            } else {
                this.searchResults = []
                this.loadingResults = false
            }
        },
        goToAnimalCard(a) {
            this.$router.push({
                name: 'pwa-animal-card',
                params: {
                    animalId: a.id,
                    animalToCard: a
                }
            })
        }
    }
}
</script>

<style scoped></style>
